// extracted by css-extract-rspack-plugin
export default {"wrap":"CompanyLogoFileController_wrap__DDIJN","input":"CompanyLogoFileController_input__TVsYM","img":"CompanyLogoFileController_img__aQ6Sq"};